
<div class="full-page">
  @if (shouldShowNavBar) {
    <div class="side-navigation">
      <jhmc-nav-bar></jhmc-nav-bar>
    </div>
  }
  <div class="outlet">
    <router-outlet></router-outlet>
  </div>
</div>
@if (!!stripeTransactionId) {
  <jhm-transaction-complete
    [transactionId]="stripeTransactionId"
    [status]="stripeStatus"
    (closeModal)="closeStripeModal()">
  </jhm-transaction-complete>
}
@if (toastMessage) {
    <jhm-toast
        [message]="toastMessage.message"
        [type]="toastMessage.type"
        (closed)="clearToast()">
    </jhm-toast>
}